import React from 'react';

import { Action, Block, Entrance, Field, Flat, ID, Shaxmatka } from 'modules/shaxmatka';

export interface Params {
  blockId: number;
  entranceId: number;
  fieldId: number;
  selected: number[];
  action?: Action | null;
  repaired: boolean;
}

export interface Methods {
  openAction(action: Action): void;
  closeAction(): void;
  setRepaired(repaired: boolean): void;
  changeBlockId(blockId?: number): void;
  changeEntranceId(entranceId?: number): void;
  changeFieldId(fieldId?: number): void;
  changeSelected: React.Dispatch<React.SetStateAction<number[]>>;
  changeCopy: React.Dispatch<React.SetStateAction<Flat | null>>;
  changeParams: (params: Partial<Params>) => void;
}

export interface IContext extends Params {
  isLoading: boolean;

  // Shaxmatka
  shaxmatka: Shaxmatka.Main;

  // House
  houseId: number;
  copyFlat?: Flat;

  // Entrance
  entrance: Entrance | null;
  entrances: Entrance[];
  isEntrancesLoading: boolean;
  isEntrancesFetching: boolean;

  // Block
  block: Block;
  blocks: Block[];
  isBlockLoading: boolean;
  isBlockFetching: boolean;
  isFlatExist: boolean;

  // Flat
  flats: Record<ID, Flat>;
  flatId: number;
  flat?: Flat;
  copy: Flat | null;

  field: {
    array: Field[];
    list: Record<number, Field>;
  };

  methods: Methods;
}

const ShaxmatkaContext = React.createContext<IContext>({} as IContext);

export default ShaxmatkaContext;
